<div
  imTooltip="{{ bannerInfo?.tooltip | translate }}"
  class="property-banner__content"
  [class]="bannerInfo?.color"
>
  @if (bannerInfo?.icon === 'check') {
    <i class="icon icon--check-framed"></i>
  }
  {{ bannerInfo?.label | translate }}
</div>
